const noop = () => undefined;

export { noop };
